function OffenderAbsenceSchedule(aSchedule) {
    this.__type = 'OffenderAbsenceSchedule:www.veritracks.com';
    this.Id = -1;
    this.Reason = '';
    this.EnrolleeId = -1;
    this.IsFriday = false;
    this.IsMonday = false;
    this.IsSaturday = false;
    this.IsSunday = false;
    this.IsThursday = false;
    this.IsTuesday = false;
    this.IsWednesday = false;
    this.StartDate = ' ';
    this.StartTime = '';
    this.StopTime = '';
    this.IsActive = true;
    this.IsRecurring = true;
    this.ScheduleTypeId = -1;
    this.EntityId = -1;
    this.ZoneScheduleType = -1;
    this.TransactionId = '';
    this.TitleUpdatedFlag = false;
    this.MonScheduleId = -1;
    this.TueScheduleId = -1;
    this.WedScheduleId = -1;
    this.ThuScheduleId = -1;
    this.FriScheduleId = -1;
    this.SatScheduleId = -1;
    this.SunScheduleId = -1;

    if (aSchedule) {
        this.Id = aSchedule.Id;
        this.Reason = aSchedule.Name;
        this.EnrolleeId = aSchedule.EnrolleeId;
        this.IsFriday = convertBoolToInteger(aSchedule.IsFriday);
        this.IsMonday = convertBoolToInteger(aSchedule.IsMonday);
        this.IsSaturday = convertBoolToInteger(aSchedule.IsSaturday);
        this.IsSunday = convertBoolToInteger(aSchedule.IsSunday);
        this.IsThursday = convertBoolToInteger(aSchedule.IsThursday);
        this.IsTuesday = convertBoolToInteger(aSchedule.IsTuesday);
        this.IsWednesday = convertBoolToInteger(aSchedule.IsWednesday);
        this.IsActive = convertBoolToInteger(aSchedule.IsActive);
        this.IsRecurring = convertBoolToInteger(aSchedule.IsRecurring);
        this.ScheduleTypeId = aSchedule.ScheduleType;
        this.EntityId = aSchedule.EntityId;
        this.ZoneScheduleType = aSchedule.ZoneScheduleType;
        this.TransactionId = moment().format("YYYYMMDDHHmmss");
        this.TitleUpdatedFlag = (aSchedule.TitleUpdatedFlag ? 1 : 0);
    }
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderAbsenceSchedule;
}